import { PartsType, PartsID } from "./consts";

//images
//hair
import { ReactComponent as DefaultHair } from "../assets/hair/default_hair.svg";
import { ReactComponent as ShavedHair } from "../assets/hair/shaved_hair.svg";
import { ReactComponent as BossHair } from "../assets/hair/boss_hair.svg";
import { ReactComponent as DinosaurCostume } from "../assets/hair/dinosaur_costume.svg";
import { ReactComponent as KumaCostume } from "../assets/hair/kuma_costume.svg";
import { ReactComponent as HiyokoCostume } from "../assets/hair/hiyoko_costume.svg";
import { ReactComponent as PandaCostume } from "../assets/hair/panda_costume.svg";
import { ReactComponent as FishCostume } from "../assets/hair/fish_costume.svg";
import { ReactComponent as RaccoonCostume } from "../assets/hair/raccoon_costume.svg";
import { ReactComponent as SharkCostume } from "../assets/hair/shark_costume.svg";
import { ReactComponent as CatCostume } from "../assets/hair/cat_costume.svg";
import { ReactComponent as SlothCostume } from "../assets/hair/sloth_costume.svg";
import { ReactComponent as LionCostume } from "../assets/hair/lion_costume.svg";
import { ReactComponent as MouseCostume } from "../assets/hair/mouse_costume.svg";
import { ReactComponent as CowCostume } from "../assets/hair/cow_costume.svg";
import { ReactComponent as TigerCostume } from "../assets/hair/tiger_costume.svg";
import { ReactComponent as RabbitCostume } from "../assets/hair/rabbit_costume.svg";
import { ReactComponent as DragonCostume } from "../assets/hair/dragon_costume.svg";
import { ReactComponent as SnakeCostume } from "../assets/hair/snake_costume.svg";
import { ReactComponent as HorseCostume } from "../assets/hair/horse_costume.svg";
import { ReactComponent as SheepCostume } from "../assets/hair/sheep_costume.svg";
import { ReactComponent as MonkeyCostume } from "../assets/hair/monkey_costume.svg";
import { ReactComponent as BirdCostume } from "../assets/hair/bird_costume.svg";

import { ReactComponent as DogCostume } from "../assets/hair/dog_costume.svg";
import { ReactComponent as BoarCostume } from "../assets/hair/boar_costume.svg";

import { ReactComponent as IchigoCostume } from "../assets/hair/ichigo_costume.svg";
import { ReactComponent as PeachCostume } from "../assets/hair/peach_costume.svg";
import { ReactComponent as AppleCostume } from "../assets/hair/apple_costume.svg";
import { ReactComponent as OrangeCostume } from "../assets/hair/orange_costume.svg";
import { ReactComponent as TaiyakiCostume } from "../assets/hair/taiyaki_costume.svg";
import { ReactComponent as MaikoCostume } from "../assets/hair/maiko_costume.svg";
import { ReactComponent as SuperHeroCostume } from "../assets/hair/superhero_costume.svg";
import { ReactComponent as HeartCostume } from "../assets/hair/heart_costume.svg";
//eyebrow
import { ReactComponent as None } from "../assets/other/none.svg";
import { ReactComponent as Eyebrow } from "../assets/eyebrow/eyebrow.svg";
import { ReactComponent as Eyebrow2 } from "../assets/eyebrow/eyebrow2.svg";
import { ReactComponent as Eyebrow3 } from "../assets/eyebrow/eyebrow3.svg";
import { ReactComponent as Eyebrow4 } from "../assets/eyebrow/eyebrow4.svg";
import { ReactComponent as DefaultEyes } from "../assets/eyes/default_eyes.svg";
import { ReactComponent as KyoroEyes } from "../assets/eyes/kyoro_eyes.svg";
import { ReactComponent as RoundEyes } from "../assets/eyes/round_eyes.svg";
import { ReactComponent as CuteEyes } from "../assets/eyes/cute_eyes.svg";
import { ReactComponent as CuteEyes2 } from "../assets/eyes/cute_eyes2.svg";
import { ReactComponent as SleepingEyes } from "../assets/eyes/sleeping_eyes.svg";
import { ReactComponent as ClosedEyes } from "../assets/eyes/closed_eyes.svg";
import { ReactComponent as ClosedEyes2 } from "../assets/eyes/closed_eyes2.svg";

//nose
import { ReactComponent as DefaultNose } from "../assets/nose/default_nose.svg";

//mouth
import { ReactComponent as DefaultMouth } from "../assets/mouth/default_mouth.svg";
import { ReactComponent as DefaultMouth2 } from "../assets/mouth/default_mouth2.svg";
import { ReactComponent as CodRoeMouth } from "../assets/mouth/cod_roe_mouth.svg";
import { ReactComponent as HeartMouth } from "../assets/mouth/heart_mouth.svg";
import { ReactComponent as NikoMouth } from "../assets/mouth/niko_mouth.svg";
import { ReactComponent as CloseMouth} from "../assets/mouth/close_mouth.svg";

//glasses
import { ReactComponent as OrdinaryGlasses } from "../assets/glasses/ordinary_glasses.svg";
import { ReactComponent as HeartGlasses } from "../assets/glasses/heart_glasses.svg";
import { ReactComponent as PharaohGlasses } from "../assets/glasses/pharaoh_glasses.svg";
import { ReactComponent as Sunglasses } from "../assets/glasses/sunglasses.svg";

//other
import { ReactComponent as Heart } from "../assets/other/heart1.svg";
import { ReactComponent as Heart2 } from "../assets/other/heart2.svg";
import { ReactComponent as Cactus } from "../assets/other/cactus.svg";
import { ReactComponent as Baby } from "../assets/other/baby.svg";
import { ReactComponent as KumaFigure } from "../assets/other/kuma_figure.svg";
import { ReactComponent as Fun } from "../assets/other/fun.svg";
import { ReactComponent as PowerDrink } from "../assets/other/power_drink.svg";
import { ReactComponent as Kanpai} from "../assets/other/kanpai.svg";
import { ReactComponent as Poem } from "../assets/other/poem1.svg";
import { ReactComponent as Poem2 } from "../assets/other/poem2.svg";


const config = {
  category_order: [
    PartsType.Hair,
    PartsType.Eyebrow,
    PartsType.Eyes,
    PartsType.Nose,
    PartsType.Mouth,
    PartsType.Glasses,
    PartsType.Other
  ],
  category_info: {
    [PartsType.Hair]: {
      key: PartsType.Hair,
      zIndex: 10,
      name: "かみがた",
      order: [
        PartsID.DefaultHair,
        PartsID.ShavedHair,
        PartsID.BossHair,
        PartsID.HeartCostume,
        PartsID.DinosaurCostume,
        PartsID.KumaCostume,
        PartsID.HiyokoCostume,
        PartsID.PandaCostume,
        PartsID.FishCostume,
        PartsID.SharkCostume,
        PartsID.RaccoonCostume,
        PartsID.CatCostume,
        PartsID.SlothCostume,
        PartsID.LionCostume,
        PartsID.MouseCostume,
        PartsID.CowCostume,
        PartsID.TigerCostume,
        PartsID.RabbitCostume,
        PartsID.DragonCostume,
        PartsID.SnakeCostume,
        PartsID.HorseCostume,
        PartsID.SheepCostume,
        PartsID.MonkeyCostume,
        PartsID.BirdCostume,
        PartsID.DogCostume,
        PartsID.BoarCostume,
        PartsID.IchigoCostume,
        PartsID.PeachCostume,
        PartsID.AppleCostume,
        PartsID.OrangeCostume,
        PartsID.TaiyakiCostume,
        PartsID.MaikoCostume,
        PartsID.SuperHeroCostume,
      ],
    },
    [PartsType.Eyebrow]: {
      key: PartsType.Eyebrow,
      zIndex: 20,
      name: "まゆげ",
      order: [
        PartsID.None,
        PartsID.Eyebrow,
        PartsID.Eyebrow2,
        PartsID.Eyebrow3,
        PartsID.Eyebrow4,
      ],
    },
    [PartsType.Eyes]: {
      key: PartsType.Eyes,
      zIndex: 20,
      name: "　め　",
      order: [
        PartsID.DefaultEyes,
        PartsID.KyoroEyes,
        PartsID.RoundEyes,
        PartsID.CuteEyes,
        PartsID.CuteEyes2,
        PartsID.SleepingEyes,
        PartsID.ClosedEyes,
        PartsID.ClosedEyes2,
      ],
    },
    [PartsType.Nose]: {
      key: PartsType.Nose,
      zIndex: 20,
      name: "はな",
      order: [
        PartsID.DefaultNose,
      ],
    },
    [PartsType.Mouth]: {
      key: PartsType.Mouth,
      zIndex: 20,
      name: "くち",
      order: [
        PartsID.DefaultMouth,
        PartsID.DefaultMouth2,
        PartsID.CodRoeMouth,
        PartsID.HeartMouth,
        PartsID.NikoMouth,
        PartsID.CloseMouth,
      ],
    },
    [PartsType.Glasses]: {
      key: PartsType.Glasses,
      zIndex: 30,
      name: "メガネ",
      order: [
        PartsID.None,
        PartsID.OrdinaryGlasses,
        PartsID.HeartGlasses,
        PartsID.PharaohGlasses,
        PartsID.Sunglasses,
      ],
    },
    [PartsType.Other]: {
      key: PartsType.Other,
      zIndex: 20,
      name: "その他",
      order: [
        PartsID.None,
        PartsID.Heart,
        PartsID.Heart2,
        PartsID.Cactus,
        PartsID.Baby,
        PartsID.KumaFigure,
        PartsID.Fun,
        PartsID.PowerDrink,
        PartsID.Kanpai,
        PartsID.Poem,
        PartsID.Poem2,
      ],
    },
  },
  parts_info: {
    [PartsID.DefaultHair]: {
      name: "ミニボブ",
      component: DefaultHair,
    },
    [PartsID.ShavedHair]: {
      name: "ぼうず",
      component: ShavedHair,
    },
    [PartsID.BossHair]: {
      name: "ボス",
      component: BossHair,
    },
    [PartsID.HeartCostume]: {
      name: "ハート",
      component: HeartCostume,
    },
    [PartsID.DinosaurCostume]: {
      name: "きょうりゅう",
      component: DinosaurCostume,
    },
    [PartsID.KumaCostume]: {
      name: "くま",
      component: KumaCostume,
    },
    [PartsID.HiyokoCostume]: {
      name: "ひよこ",
      component: HiyokoCostume,
    },
    [PartsID.PandaCostume]: {
      name: "パンダ",
      component: PandaCostume,
    },
    [PartsID.FishCostume]: {
      name: "魚",
      component: FishCostume,
    },
    [PartsID.SharkCostume]: {
      name: "サメ",
      component: SharkCostume,
    },
    [PartsID.RaccoonCostume]: {
      name: "たぬき",
      component: RaccoonCostume,
    },
    [PartsID.CatCostume]: {
      name: "ねこ",
      component: CatCostume,
    },
    [PartsID.SlothCostume]: {
      name: "なまけもの",
      component: SlothCostume,
    },
    [PartsID.LionCostume]: {
      name: "ライオン",
      component: LionCostume,
    },
    [PartsID.MouseCostume]: {
      name: "ねずみ",
      component: MouseCostume,
    },
    [PartsID.CowCostume]: {
      name: "うし",
      component: CowCostume,
    },
    [PartsID.TigerCostume]: {
      name: "とら",
      component: TigerCostume,
    },
    [PartsID.RabbitCostume]: {
      name: "うさぎ",
      component: RabbitCostume,
    },
    [PartsID.DragonCostume]: {
      name: "ドラゴン",
      component: DragonCostume,
    },
    [PartsID.SnakeCostume]: {
      name: "へび",
      component: SnakeCostume,
    },
    [PartsID.HorseCostume]: {
      name: "うま",
      component: HorseCostume,
    },
    [PartsID.SheepCostume]: {
      name: "ひつじ",
      component: SheepCostume,
    },
    [PartsID.MonkeyCostume]: {
      name: "さる",
      component: MonkeyCostume,
    },
    [PartsID.BirdCostume]: {
      name: "とり",
      component: BirdCostume,
    },
    [PartsID.DogCostume]: {
      name: "いぬ",
      component: DogCostume,
    },
    [PartsID.BoarCostume]: {
      name: "いのしし",
      component: BoarCostume,
    },
    [PartsID.IchigoCostume]: {
      name: "いちご",
      component: IchigoCostume,
    },
    [PartsID.PeachCostume]: {
      name: "もも",
      component: PeachCostume,
    },
    [PartsID.AppleCostume]: {
      name: "りんご",
      component: AppleCostume,
    },
    [PartsID.OrangeCostume]: {
      name: "オレンジ",
      component: OrangeCostume,
    },
    [PartsID.TaiyakiCostume]: {
      name: "たい焼き",
      component: TaiyakiCostume,
    },
    [PartsID.MaikoCostume]: {
      name: "舞妓さん",
      component: MaikoCostume,
    },
    [PartsID.SuperHeroCostume]: {
      name: "スーパーヒーロー",
      component: SuperHeroCostume,
    },
    [PartsID.None]: {
      name: "なし",
      component: None,
    },
    [PartsID.Eyebrow]: {
      name: "まゆげ",
      component: Eyebrow,
    },
    [PartsID.Eyebrow2]: {
      name: "まゆげ2",
      component: Eyebrow2,
    },
    [PartsID.Eyebrow3]: {
      name: "まゆげ3",
      component: Eyebrow3,
    },
    [PartsID.Eyebrow4]: {
      name: "まゆげ4",
      component: Eyebrow4,
    },
    [PartsID.DefaultEyes]: {
      name: "デフォルト",
      component: DefaultEyes,
    },
    [PartsID.KyoroEyes]: {
      name: "キョロキョロ",
      component: KyoroEyes,
    },
    [PartsID.RoundEyes]: {
      name: "まあるい",
      component: RoundEyes,
    },
    [PartsID.CuteEyes]: {
      name: "可愛い",
      component: CuteEyes,
    },
    [PartsID.CuteEyes2]: {
      name: "可愛い2",
      component: CuteEyes2,
    },
    [PartsID.SleepingEyes]: {
      name: "華やか",
      component: SleepingEyes,
    },
    [PartsID.ClosedEyes]: {
      name: "閉じてる",
      component: ClosedEyes,
    },
    [PartsID.ClosedEyes2]: {
      name: "閉じてる2",
      component: ClosedEyes2,
    },
    [PartsID.DefaultNose]: {
      name: "デフォルト",
      component: DefaultNose,
    },
    [PartsID.DefaultMouth]: {
      name: "デフォルト",
      component: DefaultMouth,
    },
    [PartsID.DefaultMouth2]: {
      name: "デフォルト2",
      component: DefaultMouth2,
    },
    [PartsID.CodRoeMouth]: {
      name: "たらこ",
      component: CodRoeMouth,
    },
    [PartsID.HeartMouth]: {
      name: "ハート",
      component: HeartMouth,
    },
    [PartsID.NikoMouth]: {
      name: "ニコニコ",
      component: NikoMouth,
    },
    [PartsID.CloseMouth]: {
      name: "むむっ！",
      component: CloseMouth,
    },
    [PartsID.OrdinaryGlasses]: {
      name: "メガネ",
      component: OrdinaryGlasses,
    },
    [PartsID.HeartGlasses]: {
      name: "ハートメガネ",
      component: HeartGlasses,
    },
    [PartsID.PharaohGlasses]: {
      name: "ファラオ様",
      component: PharaohGlasses,
    },
    [PartsID.Sunglasses]: {
      name: "サングラス",
      component: Sunglasses,
    },
    [PartsID.Heart]: {
      name: "ハート",
      component: Heart,
    },
    [PartsID.Heart2]: {
      name: "ハート2",
      component: Heart2,
    },
    [PartsID.Cactus]: {
      name: "サボテン",
      component: Cactus,
    },
    [PartsID.Baby]: {
      name: "赤ちゃん",
      component: Baby,
    },
    [PartsID.KumaFigure]: {
      name: "応援団",
      component: KumaFigure,
    },
    [PartsID.Fun]: {
      name: "ファン",
      component: Fun,
    },
    [PartsID.PowerDrink]: {
      name: "パワー飲料",
      component: PowerDrink,
    },
    [PartsID.Kanpai]: {
      name: "乾杯",
      component: Kanpai,
    },
    [PartsID.Poem]: {
      name: "ポエム",
      component: Poem,
    },
    [PartsID.Poem2]: {
      name: "ポエム2",
      component: Poem2,
    },
  },
};

export default config;
